module.exports = __webpack_public_path__ + "fonts/GothamMedium.e19c20e9.otf";